/**
 * ProductMain - product page main container coordinating gallery, form and details.
 * Custom element: <product-main>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ProductMain extends ThemeComponent {}
setFunctionName(ProductMain, "ProductMain");
const propertyTypes = {};
ProductMain.prototype.$name = "ProductMain";
ProductMain.prototype.$info = JSON.parse('{"name":"ProductMain","meta":{"isLegacy":false,"selector":"product-main"},"props":[],"refs":[]}');
ProductMain.prototype.$info.component = ProductMain;
for (const prop of ProductMain.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductMain.ts", {
  ProductMain: ProductMain
}, void 0);